import styled from "styled-components";
import { colors } from "@/theme";

export const LoginAsAdminDialogContentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  row-gap: 24px;
  padding: 48px 0 0;
`;

export const LoginAsAdminDialogContentAvatarContainer = styled.div``;

export const LoginAsAdminDialogContentTitle = styled.div`
  color: ${colors.fieldTextHelper};
  text-align: center;
  font-family: "PF DIN Text Pro";
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  text-transform: uppercase;
`;
